module.exports = __webpack_public_path__ + "img/img_3.c33e3033.png";